import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { Wallet2 } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { PaymentCard } from '../../components/PaymentCard';

export const ViewPaymentPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onCancel = () => {
    navigate(-1);
  };

  return (
    <>
      <PageTitle title={t('common.label.payment')} icon={Wallet2} />

      <PaymentCard id={id!} />

      <BtnToolbar>
        <BtnGroup>
          <Button action={ButtonAction.return} variant="secondary" onClick={onCancel} />
        </BtnGroup>
        <BtnGroup>
          <></>
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
